/* FENDO: product video lifecycle. Existing player controls and docking geometry are preserved. */
(function () {
  if (window.__productVideoModalInit) return;
  window.__productVideoModalInit = true;

  var controllers = new Map();
  var sectionObservers = new Map();
  var suspendedSections = new WeakSet();
  var sessions = new Map();
  var pendingRoots = new Set();
  var refreshFrame = null;
  var updateFrame = null;
  var relevantNodes = 'product-gallery, [data-product-video-trigger], .product-gallery__carousel, .product-gallery__media, x-modal[data-product-video-modal]';

  function parseVideo(url) {
    if (!url) return null;
    var cleanUrl = String(url).trim();

    var yt = cleanUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    if (yt && yt[1]) return { type: 'youtube', id: yt[1] };

    var vm = cleanUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm && vm[1]) return { type: 'vimeo', id: vm[1] };

    var m = cleanUrl.match(/\.(mp4|webm|ogg)(\?|#|$)/i);
    if (m && m[1]) {
      var ext = m[1].toLowerCase();
      var mime = ext === 'mp4' ? 'video/mp4' : (ext === 'webm' ? 'video/webm' : 'video/ogg');
      return { type: 'html5', src: cleanUrl, mime: mime };
    }

    return { type: 'url', src: cleanUrl };
  }

  function destroyPlayer(container) {
    if (!container) return;
    window.clearTimeout(container.__fendoVideoPlayTimer);
    container.__fendoVideoPlayTimer = null;

    // Clear the reference before destroy(): closing must be safe more than once.
    var player = container.__plyr;
    container.__plyr = null;
    if (player) {
      try { player.pause(); } catch (e) {}
      try { player.destroy(); } catch (e) {}
    }
    container.querySelectorAll('video, audio').forEach(function (media) {
      try { media.pause(); } catch (e) {}
    });
    if (container.firstChild) container.replaceChildren();
  }

  function initPlayer(container, info) {
    if (!container || !info) return;
    destroyPlayer(container);
    var el;

    if (info.type === 'youtube' || info.type === 'vimeo') {
      el = document.createElement('div');
      el.setAttribute('data-plyr-provider', info.type);
      el.setAttribute('data-plyr-embed-id', info.id);
      container.appendChild(el);
    } else if (info.type === 'html5') {
      el = document.createElement('video');
      el.setAttribute('playsinline', '');
      el.setAttribute('controls', '');
      var source = document.createElement('source');
      source.src = info.src;
      source.type = info.mime;
      el.appendChild(source);
      container.appendChild(el);
    } else {
      el = document.createElement('iframe');
      el.src = info.src;
      el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      el.setAttribute('allowfullscreen', '');
      container.appendChild(el);
      return;
    }

    if (!window.Plyr) return;
    var player;
    try {
      player = new window.Plyr(el, {
        controls: ['play-large','play','progress','current-time','mute','volume','fullscreen'],
        ratio: '9:16',
        fullscreen: { enabled: true, fallback: true, iosNative: true }
      });
    } catch (e) {
      // Leave native HTML5 controls intact if the optional player fails to start.
      return;
    }
    container.__plyr = player;
    container.__fendoVideoPlayTimer = window.setTimeout(function () {
      container.__fendoVideoPlayTimer = null;
      if (!container.isConnected || container.__plyr !== player) return;
      var modal = container.closest('x-modal[data-product-video-modal]');
      if (!modal || !modal.hasAttribute('open')) return;
      try {
        var playing = player.play();
        if (playing && typeof playing.catch === 'function') playing.catch(function () {});
      } catch (e) {}
    }, 50);
  }

  function closeSession(modal, closeModal) {
    var session = sessions.get(modal);
    sessions.delete(modal);
    destroyPlayer(session ? session.container : modal.querySelector('[data-product-video-container]'));
    if (!closeModal || !modal.hasAttribute('open')) return;
    try {
      if (typeof modal.hide === 'function') {
        var hiding = modal.hide();
        if (hiding && typeof hiding.catch === 'function') hiding.catch(function () {});
      } else {
        modal.removeAttribute('open');
      }
    } catch (e) {
      modal.removeAttribute('open');
    }
  }

  function setClass(element, name, enabled) {
    if (element.classList.contains(name) !== enabled) element.classList.toggle(name, enabled);
  }

  function setStyle(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }

  function isOnScreenVert(rect) {
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function removeController(gallery) {
    var state = controllers.get(gallery);
    if (!state) return;
    state.carousel.removeEventListener('scroll', scheduleUpdates);
    gallery.removeEventListener('load', scheduleUpdates, true);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    controllers.delete(gallery);
    sessions.forEach(function (session, modal) {
      if (session.gallery === gallery) closeSession(modal, true);
    });
  }

  function pruneDetached() {
    controllers.forEach(function (state, gallery) {
      if (!gallery.isConnected ||
          gallery.querySelector('[data-product-video-trigger]') !== state.button ||
          gallery.querySelector('.product-gallery__carousel') !== state.carousel ||
          state.carousel.querySelector('.product-gallery__media') !== state.firstMedia) {
        removeController(gallery);
      }
    });
    sectionObservers.forEach(function (observer, section) {
      if (!section.isConnected) {
        observer.disconnect();
        sectionObservers.delete(section);
      }
    });
    sessions.forEach(function (session, modal) {
      if (!modal.isConnected || !session.trigger.isConnected || !session.gallery?.isConnected) {
        closeSession(modal, true);
      }
    });
  }

  function updateButton(state) {
    var items = state.carousel.querySelectorAll('.product-gallery__media');
    var c = state.carousel.getBoundingClientRect();
    var bestIdx = 0;
    var bestOverlap = -Infinity;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      var overlap = Math.min(r.right, c.right) - Math.max(r.left, c.left);
      if (overlap > bestOverlap) {
        bestOverlap = overlap;
        bestIdx = i;
      }
    }

    var rect = state.firstMedia.getBoundingClientRect();
    var shouldShow = bestIdx === 0 && isOnScreenVert(rect);
    setClass(state.button, 'is-hidden', !shouldShow);
    if (!shouldShow) return;

    var rightOffset = Math.round(window.innerWidth - rect.right + 18);
    if (!isFinite(rightOffset) || rightOffset < 18) rightOffset = 18;
    setStyle(state.button, '--watch-video-inline-end', rightOffset + 'px');
    setStyle(state.button, '--watch-video-docked-inline-end', '18px');
    setClass(state.button, 'is-ready', true);
    setClass(state.button, 'is-docked-to-media', rect.bottom <= window.innerHeight - 18);
  }

  function scheduleUpdates() {
    if (updateFrame !== null) return;
    updateFrame = requestAnimationFrame(function () {
      updateFrame = null;
      pruneDetached();
      controllers.forEach(updateButton);
    });
  }

  function hasRelevantNode(node) {
    return node instanceof Element && (node.matches(relevantNodes) || Boolean(node.querySelector(relevantNodes)));
  }

  function observeSection(section) {
    if (!section || sectionObservers.has(section) || suspendedSections.has(section)) return;
    var observer = new MutationObserver(function (records) {
      // No class/style observation: our own docking updates cannot retrigger setup.
      var changed = records.some(function (record) {
        return Array.from(record.addedNodes).some(hasRelevantNode) ||
          Array.from(record.removedNodes).some(hasRelevantNode);
      });
      if (changed) scheduleRefresh(section);
    });
    observer.observe(section, { childList: true, subtree: true });
    sectionObservers.set(section, observer);
  }

  function setupGallery(gallery) {
    var section = gallery.closest('.shopify-section');
    if (!gallery.isConnected || (section && suspendedSections.has(section))) return;
    var button = gallery.querySelector('[data-product-video-trigger]');
    var carousel = gallery.querySelector('.product-gallery__carousel');
    var firstMedia = carousel?.querySelector('.product-gallery__media');
    if (!button || !carousel || !firstMedia) return;
    observeSection(section);
    if (controllers.has(gallery)) return;

    var state = { button: button, carousel: carousel, firstMedia: firstMedia, section: section, resizeObserver: null };
    controllers.set(gallery, state);
    carousel.addEventListener('scroll', scheduleUpdates, { passive: true });
    gallery.addEventListener('load', scheduleUpdates, true);
    if ('ResizeObserver' in window) {
      state.resizeObserver = new ResizeObserver(scheduleUpdates);
      state.resizeObserver.observe(carousel);
      state.resizeObserver.observe(firstMedia);
    }
  }

  function refresh(root) {
    pruneDetached();
    if (root !== document && !root.isConnected) return;
    if (root instanceof Element && root.matches('product-gallery')) setupGallery(root);
    root.querySelectorAll?.('product-gallery').forEach(setupGallery);
    // Watch the main section even if it has no video yet, so later markup is noticed.
    if (root instanceof Element && root.matches('.shopify-section--main-product')) observeSection(root);
    root.querySelectorAll?.('.shopify-section--main-product').forEach(observeSection);
    scheduleUpdates();
  }

  function scheduleRefresh(root) {
    pendingRoots.add(root && root.querySelectorAll ? root : document);
    if (refreshFrame !== null) return;
    refreshFrame = requestAnimationFrame(function () {
      refreshFrame = null;
      var roots = Array.from(pendingRoots);
      pendingRoots.clear();
      roots.forEach(refresh);
    });
  }

  function modalForTrigger(trigger) {
    var id = trigger.getAttribute('aria-controls');
    if (!id) return null;
    // Prefer the current section's modal, not an old portalled modal with the same ID.
    var section = trigger.closest('.shopify-section');
    var local = section && Array.from(section.querySelectorAll('x-modal[data-product-video-modal]'))
      .find(function (modal) { return modal.id === id; });
    var modal = local || document.getElementById(id);
    return modal?.matches('x-modal[data-product-video-modal]') ? modal : null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target instanceof Element ? event.target.closest('[data-product-video-trigger]') : null;
    if (!trigger || trigger.disabled) return;
    var modal = modalForTrigger(trigger);
    // Prestige owns open/close, focus trapping and animations. Do not toggle it twice.
    if (!modal || modal.hasAttribute('open')) return;
    var container = modal.querySelector('[data-product-video-container]');
    var info = parseVideo(trigger.getAttribute('data-video-url'));
    if (!container || !info) return;
    initPlayer(container, info);
    sessions.set(modal, {
      container: container,
      trigger: trigger,
      gallery: trigger.closest('product-gallery'),
      section: trigger.closest('.shopify-section')
    });
  }, true);

  function onModalClosed(event) {
    var modal = event.target;
    if (modal instanceof Element && modal.matches('x-modal[data-product-video-modal]') && !modal.hasAttribute('open')) {
      closeSession(modal, false);
    }
  }
  document.addEventListener('toggle', onModalClosed, true);
  document.addEventListener('dialog:before-hide', onModalClosed, true);

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!(section instanceof Element)) return;
    suspendedSections.add(section);
    pendingRoots.delete(section);
    controllers.forEach(function (state, gallery) {
      if (state.section === section || section.contains(gallery)) removeController(gallery);
    });
    sectionObservers.forEach(function (observer, watchedSection) {
      if (watchedSection === section || section.contains(watchedSection)) {
        observer.disconnect();
        sectionObservers.delete(watchedSection);
      }
    });
    sessions.forEach(function (session, modal) {
      if (session.section === section || section.contains(session.trigger)) closeSession(modal, true);
    });
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target instanceof Element) suspendedSections.delete(event.target);
    scheduleRefresh(event.target);
  });
  document.addEventListener('product:rerender', function (event) {
    // This Prestige event does not bubble. Capture it, then wait for DOM replacement.
    scheduleRefresh(event.target instanceof Element ? event.target.closest('.shopify-section') : document);
  }, true);
  document.addEventListener('variant:change', scheduleUpdates);
  window.addEventListener('scroll', scheduleUpdates, { passive: true });
  window.addEventListener('resize', scheduleUpdates, { passive: true });
  window.addEventListener('pageshow', function () { scheduleRefresh(document); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(document); }, { once: true });
  } else {
    refresh(document);
  }
})();
